var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWelcome3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 298,
    height: 250,
    viewBox: "0 0 298 250",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_386_10257)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-38.7919 -11.7266H331.014V234.81H-38.7919V-11.7266Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.068 91.801C259.337 95.1395 250.404 90.8465 250.404 90.8465C250.404 90.8465 252.389 81.142 259.123 77.808C265.854 74.469 274.784 78.7575 274.784 78.7575C274.784 78.7575 272.798 88.4621 266.068 91.801Z",
    fill: "url(#paint0_linear_386_10257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.268 66.0296C254.84 68.2267 250.765 66.6053 244.922 62.7224C240.528 59.8013 236.488 57.1995 233.203 52.2006C230.903 48.703 229.611 44.9425 228.976 41.6208C228.288 38.0218 226.985 33.6388 229.897 31.528C233.897 28.6292 246.699 31.2211 254.541 42.3383C263.155 54.5521 261.62 63.8835 258.268 66.0296Z",
    fill: "url(#paint1_linear_386_10257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.694 149.024C45.5936 154.358 58.3617 149.427 58.3617 149.427C58.3617 149.427 56.6922 135.85 47.7873 130.522C38.8877 125.188 26.1249 130.113 26.1249 130.113C26.1249 130.113 27.7944 143.69 36.694 149.024Z",
    fill: "url(#paint2_linear_386_10257)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.445 112C262.418 112 259.153 115.265 259.153 119.292C259.153 123.32 262.418 126.584 266.445 126.584C270.473 126.584 273.737 123.32 273.737 119.292C273.737 115.265 270.473 112 266.445 112Z",
    fill: "#012A38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.2546 92.436C46.9391 92.436 44.2514 95.1237 44.2514 98.4392C44.2514 101.755 46.9391 104.442 50.2546 104.442C53.57 104.442 56.2578 101.755 56.2578 98.4392C56.2578 95.1237 53.57 92.436 50.2546 92.436Z",
    fill: "#012A38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.3723 182.016C57.5966 182.016 54.5358 178.955 54.5358 175.179C54.5358 171.404 57.5966 168.343 61.3723 168.343C65.1479 168.343 68.2087 171.404 68.2087 175.179C68.2087 178.955 65.1479 182.016 61.3723 182.016Z",
    fill: "#012A38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.673 130.907C286.911 130.907 285.483 129.478 285.483 127.717C285.483 125.955 286.911 124.526 288.673 124.526C290.435 124.526 291.863 125.955 291.863 127.717C291.863 129.478 290.435 130.907 288.673 130.907Z",
    fill: "#012A38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.262 164.304C240.996 164.304 239.16 162.467 239.16 160.202C239.16 157.936 240.996 156.1 243.262 156.1C245.527 156.1 247.364 157.936 247.364 160.202C247.364 162.467 245.527 164.304 243.262 164.304Z",
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.3226 208.583C47.0505 208.583 44.3979 205.93 44.3979 202.658C44.3979 199.386 47.0505 196.733 50.3226 196.733C53.5947 196.733 56.2473 199.386 56.2473 202.658C56.2473 205.93 53.5947 208.583 50.3226 208.583Z",
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.262 207.235C236.771 207.235 234.752 205.216 234.752 202.725C234.752 200.235 236.771 198.216 239.262 198.216C241.752 198.216 243.771 200.235 243.771 202.725C243.771 205.216 241.752 207.235 239.262 207.235Z",
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.653 57.3616C273.885 57.3616 271.64 55.1171 271.64 52.3483C271.64 49.5795 273.885 47.335 276.653 47.335C279.422 47.335 281.667 49.5795 281.667 52.3483C281.667 55.1171 279.422 57.3616 276.653 57.3616Z",
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5167 109.779C11.1602 112.181 9.73489 114.649 7.33314 115.293C4.93138 115.937 2.46267 114.511 1.81912 112.11C1.17557 109.708 2.60088 107.239 5.00264 106.595C7.4044 105.952 9.8731 107.377 10.5167 109.779Z",
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.3971 50.6365C75.3623 50.6365 74.5235 49.7976 74.5235 48.7628C74.5235 47.728 75.3623 46.8892 76.3971 46.8892C77.4319 46.8892 78.2708 47.728 78.2708 48.7628C78.2708 49.7976 77.4319 50.6365 76.3971 50.6365Z",
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.681 167.39C269.137 167.39 267.074 165.739 267.074 163.704C267.074 161.668 269.137 160.018 271.681 160.018C274.226 160.018 276.288 161.668 276.288 163.704C276.288 165.739 274.226 167.39 271.681 167.39Z",
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.962 17.7184C191.427 19.4571 190.396 21.2442 188.657 21.7101C186.918 22.176 185.131 21.1442 184.665 19.4055C184.199 17.6668 185.231 15.8797 186.97 15.4138C188.709 14.9479 190.496 15.9797 190.962 17.7184Z",
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2166 52.4307H44.2819C44.6706 57.9371 48.7656 58.0221 48.7656 58.0221C48.7656 58.0221 44.2503 58.1101 44.2503 64.4724C44.2503 58.1101 39.7346 58.0221 39.7346 58.0221C39.7346 58.0221 43.8279 57.9371 44.2166 52.4307Z",
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.783 36.1545L211.673 64.0695C214.949 67.3489 216.79 71.7943 216.791 76.4296V186.708C216.791 196.369 208.975 204.19 199.327 204.19H100.705C91.0571 204.19 83.2407 196.369 83.2407 186.708V48.5147C83.2407 38.8533 91.0571 31.0327 100.705 31.0327H171.437C173.73 31.0338 176.001 31.4866 178.119 32.3654C180.238 33.2443 182.162 34.5318 183.783 36.1545Z",
    fill: "white",
    stroke: "#EFEFEF",
    strokeWidth: 4.51984
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.828 173.304H181.323M112.912 101.054H147.093H112.912ZM112.912 82.1523H147.093H112.912ZM112.912 124.637H173.784H112.912ZM112.828 149.062H181.323H112.828Z",
    stroke: "#EFEFEF",
    strokeWidth: 9.86148,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M263.307 87.5586V48.4538C263.308 41.7237 259.072 35.7156 252.716 33.4343L228.281 24.6716C219.86 21.6518 210.65 21.6518 202.229 24.6716L177.762 33.4503C171.411 35.7296 167.176 41.7295 167.171 48.4538V87.5586C167.171 107.877 195.707 122.912 208.83 128.771C210.845 129.677 213.029 130.145 215.239 130.145C217.448 130.145 219.633 129.677 221.648 128.771C234.771 122.913 263.307 107.845 263.307 87.5586Z",
    fill: "#FF3300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.826 100.859H217.505C218.567 100.859 219.449 99.9913 219.449 98.9163V94.4225L220.421 94.1633C228.353 92.1688 231.166 86.7169 231.166 82.6633C231.166 75.1516 224.685 72.0306 218.334 69.9584C212.372 67.99 210.467 66.7982 210.467 65.0368C210.467 63.457 212.294 61.8766 216.39 61.8766C220.901 61.8766 223.726 63.1586 224.931 63.7157C225.191 63.8319 225.463 63.8972 225.735 63.8972C226.486 63.8972 227.173 63.457 227.497 62.7831L229.351 58.8588C229.571 58.4056 229.597 57.8615 229.416 57.3822C229.247 56.8898 228.884 56.5012 228.418 56.2811C226.188 55.2323 223.765 54.5583 221.03 54.235L219.889 54.0927V50.1945C219.889 49.1326 219.02 48.2646 217.945 48.2646H213.343C212.281 48.2646 211.399 49.1326 211.399 50.1945V54.5328L210.427 54.7791C204.024 56.398 200.201 60.5032 200.201 65.7487C200.201 72.6647 207.057 75.7466 213.784 77.858C219.992 79.8786 220.835 81.6269 220.835 83.0773C220.835 85.318 217.932 86.9494 213.94 86.9494C210.544 86.9494 206.889 86.0815 204.167 84.631C203.882 84.4756 203.571 84.3979 203.246 84.3979C203.039 84.3979 202.831 84.437 202.624 84.5017C202.119 84.6833 201.704 85.0588 201.484 85.5506L199.695 89.5265C199.293 90.446 199.63 91.5079 200.511 92.0003C202.779 93.3084 206.149 94.2795 209.727 94.6812L210.88 94.798V98.9163C210.881 99.9913 211.75 100.859 212.826 100.859Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_386_10257",
    x1: 240.221,
    y1: 102.216,
    x2: 295.736,
    y2: 58.3027,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEEEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_386_10257",
    x1: 235.603,
    y1: 80.0268,
    x2: 257.478,
    y2: 1.35067,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEEEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_386_10257",
    x1: 71.1331,
    y1: 166.193,
    x2: -0.476421,
    y2: 99.6584,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEEEE"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_386_10257"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 297,
    height: 249.666,
    fill: "white",
    transform: "translate(0.5 0.166992)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWelcome3);
export default __webpack_public_path__ + "static/media/welcome3.d90ea49a.svg";
export { ForwardRef as ReactComponent };